import { mdiBookshelf } from '@mdi/js'

export default {
  title: 'Lesson',
  to: 'lesson-list',
  icon: mdiBookshelf,
  action: 'read',
  subject: 'LessonSchool',
}
